module.exports = __webpack_public_path__ + "img/banner5_zh_m.3fa7be89.png";